import React from 'react'
import {Context as AppContext} from '../../contexts/App'

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';


const ClientSelection = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { suppliers } = app.suppliers
  const { selectedProducts, setSelectedProducts, assignSupplier } = app.products

  const title = selectedProducts?`Asignar proveedor a ${selectedProducts.length} producto${selectedProducts.length>1?'s':''}`:''
  return (
    <Dialog onClose={() => setSelectedProducts(false)} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <List sx={{ pt: 0 }}>
        {suppliers.map((supplier) => (
          <ListItem Button onClick={() => {close();assignSupplier(supplier.id);}} key={supplier.name}>
            <ListItemText primary={supplier.name} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  )
}
export default ClientSelection